import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d40cd82&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5d40cd82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40cd82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d40cd82')) {
      api.createRecord('5d40cd82', component.options)
    } else {
      api.reload('5d40cd82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d40cd82&scoped=true&", function () {
      api.rerender('5d40cd82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/txPairManage/index.vue"
export default component.exports